import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

@Injectable({ providedIn: 'root' })
export class HapticsService {
  private readonly isNative = Capacitor.isNativePlatform();

  async impact(style: ImpactStyle = ImpactStyle.Medium): Promise<void> {
    if (!this.isNative) return;
    await Haptics.impact({ style });
  }

  async notification(type: NotificationType = NotificationType.Success): Promise<void> {
    if (!this.isNative) return;
    await Haptics.notification({ type });
  }

  async selectionTick(): Promise<void> {
    if (!this.isNative) return;
    await Haptics.selectionStart();
    await Haptics.selectionChanged();
    await Haptics.selectionEnd();
  }

  // Convenience methods
  async success(): Promise<void> {
    await this.notification(NotificationType.Success);
  }

  async error(): Promise<void> {
    await this.notification(NotificationType.Error);
  }

  async warning(): Promise<void> {
    await this.notification(NotificationType.Warning);
  }

  async light(): Promise<void> {
    await this.impact(ImpactStyle.Light);
  }

  async heavy(): Promise<void> {
    await this.impact(ImpactStyle.Heavy);
  }
}
